import { type StatsTableColumn } from '~/apps/product-plus/components/BettingInsights/types';

export const formatStatValue = (
  value: string | number,
  type: StatsTableColumn['type'],
  formatDate: (date: string, format?: string) => string,
): string => {
  if (type === 'TIMESTAMP') {
    return formatDate(`${value}`, 'MM/dd');
  }

  if (type === 'STRING') {
    return `${value}`;
  }

  // Handle numbers (both NUMBER and PERCENTAGE)
  const num = typeof value === 'number' ? value : parseFloat(`${value}`);
  const formattedNum = Number.isInteger(num) ? num.toString() : num.toFixed(1);
  return type === 'PERCENTAGE' ? `${formattedNum}%` : formattedNum;
};
